import './toggleButton.css';
import PropTypes from 'prop-types';
import React from 'react';

//import toggleOn from '../img/toggleOn.svg';
//import toggleOn_Skyblue from '../img/toggleOn_skyblue.svg';
import toggleOn_blue from '../img/toggleOn_blue.svg';
//import toggleOff from '../img/toggleOff.svg';
import toggleOffDisabled from '../img/toggleOffDisabled.svg';
// import toggleOffDisabledhover from '../img/toggleOffDisabledhover.svg';
// import toggleOn_bluehover from '../img/toggleOn_bluehover.svg';


function ToggleButton({
    value,
    onChange = () => {},
    disabled,
    isHovered,
    ...other
}: {
  value: boolean,
  onChange?: (x: boolean) => void,
  disabled?: boolean,
  isHovered?: boolean,
  [x: string]: any
}) {


  function getIconSrc() {
    if (disabled) return toggleOffDisabled;

    // Issue - #1704 : 기존 색상과 동일하게 처리(Doc. Server에 마우스 오버시 버튼의 색이 빨간색으로 변하는 부분을 #0079A4 색으로 변경)
    // if (isHovered){
    //   if(value)
    //     return toggleOn_bluehover
    //   else
    //     return toggleOffDisabledhover
    // }
     
    return value ? toggleOn_blue : toggleOffDisabled;
  }
  function toggle() {
    if (disabled) return;
    else onChange(!value);
  }
    return (
      <img 
        className="ifms-toggle-button" 
        src={getIconSrc()} 
        alt="" 
        onClick={toggle} 
        {...other} 
      />
    );

    // if (disabled)
    //   return <img className="ifms-toggle-button" src={toggleOffDisabled} alt="" onClick={toggle} {...other} />
    // else
    //   //return <img className="ifms-toggle-button" src={value ? toggleOn : toggleOff} alt="" onClick={toggle} {...other} />
    //   return <img className="ifms-toggle-button" src={value ? toggleOn_blue : toggleOffDisabled} alt="" onClick={toggle} {...other} />


}

ToggleButton.defaultProps = {
  onChange: () => {
  },
  value: false,
  disabled: false,
  isHovered: false,
};

ToggleButton.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  isHovered: PropTypes.bool.isRequired,
};


export default React.memo(ToggleButton);
